import { motion } from "framer-motion";
import { PROCESS } from "@/data/site";

export default function Manifesto() {
  return (
    <section className="py-24 md:py-36 bg-[color:var(--bg-charcoal)] text-white relative overflow-hidden" data-testid="manifesto-section">
      <div className="absolute inset-0 halftone-bg opacity-[0.06] halftone-fade" aria-hidden />
      <div className="relative max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="md:col-span-8"
          >
            <div className="font-mono text-[11px] tracking-[0.28em] uppercase text-white/60 mb-6">— The Manifesto</div>
            <h2 className="font-display text-[44px] md:text-[80px] leading-[0.98] tracking-[-0.02em]">
              Four chapters between an <em className="italic text-[color:var(--accent)]">idea</em> and the finished print.
            </h2>
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="md:col-span-4 text-white/70 text-[16px] leading-[1.65]"
          >
            No shortcuts. No guesswork. Every project moves through the same four disciplined steps — the reason we've earned three decades of returning clients.
          </motion.p>
        </div>

        <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-14 md:gap-y-24">
          {PROCESS.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: i * 0.1, ease: [0.7, 0, 0.2, 1] }}
              className="relative border-t border-white/10 pt-8 md:pt-10 group"
              data-testid={`process-step-${p.n}`}
            >
              <div className="flex items-start gap-6 md:gap-10">
                <div className="dot-number-light font-display text-[76px] md:text-[128px] leading-none tracking-tight">
                  {p.n}
                </div>
                <div className="flex-1 pt-2">
                  <h3 className="font-display text-3xl md:text-4xl leading-tight">{p.title}</h3>
                  <p className="mt-4 text-white/70 text-[15.5px] leading-[1.7] max-w-[420px]">{p.body}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
